import {
  GET_ALERT_NOTIFICATIONS_FULFILLED,
  AlertNotificationActionTypes,
  AlertNotificationState,
  DELETE_ALERT_NOTIFICATION_FULFILLED,
} from './alertNotification.types';

const initialState: AlertNotificationState = {
  entities: [],
};

export default function alertNotificationReducer(
  state = initialState,
  action: AlertNotificationActionTypes,
): AlertNotificationState {
  switch (action.type) {
    case GET_ALERT_NOTIFICATIONS_FULFILLED:
      return { ...state, entities: action.payload.data.data || [] };
    case DELETE_ALERT_NOTIFICATION_FULFILLED:
      return { ...state, entities: state.entities.filter((entity) => entity.id !== JSON.parse(action.payload.config.data).recordName) };
    default:
      return state;
  }
}
